const _Singleton = class _Singleton {
  constructor() {
  }
  static getInstance(klass) {
    const instances = _Singleton._instances;
    const instance = instances.get(klass);
    const isInstanceOfKlass = instance instanceof klass;
    if (isInstanceOfKlass) {
      return instance;
    }
    const newInstance = new klass();
    instances.set(klass, newInstance);
    return newInstance;
  }
};
_Singleton._instances = /* @__PURE__ */ new Map();
let Singleton = _Singleton;

export { Singleton };
//# sourceMappingURL=singleton.mjs.map
